/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1UserType } from '../../entities/v1/UserType'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1UserTypeSchema = z.enum(['new', 'old']) as unknown as ToZod<V1UserType>